/// <reference path="../../../services/data.service.ts" />
import { Location } from '@angular/common';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/services/PermissionsService';
import { CcService } from '../../../services/cc.service';
import { DataService } from '../../../services/data.service';
import { PasService } from '../../../services/pas.service';
import { RouterService } from '../../../services/router.service';
import { StockService } from '../../../services/stock.service';
import { Icc } from '../../Interfaces/icc';
import { stock, stockResponse, stockstatus } from '../../Interfaces/ipas';
import { IuserPermissionsResponse } from '../../Interfaces/iuser';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';

@Component({
  selector: 'app-pricechecker',
  templateUrl: './pricechecker.component.html'
})

export class PriceCheckerComponent implements OnInit, AfterViewInit {

  formReport: FormGroup;
  subRef$: Subscription;

  r_gridregs:number= 0;
  public companyId: string;
  userId: string;
  matcher = new ErrorStateMatcher1();
  message: string="";
  Columns: string[] = [];
  DataGrid: stockResponse[] = [];
  dataList = new MatTableDataSource;
  Permissions: IuserPermissionsResponse[] = [];
  MenuG: IuserPermissionsResponse[] = [];
  permissionsList = null;
  menuGList =new MatTableDataSource;
  filtermenu = { type: 'G' };
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
/*  @ViewChild('cc_id', { static: false }) cc_id!:MatInput;*/
  @ViewChild('code', { static:true }) inputCodeRef!: ElementRef<HTMLInputElement>;

  ngAfterViewInit() {
    this.dataList.paginator = this.paginator;
  }


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private dataService: DataService,
    //private securityService: SecurityService,
    private permissionservice: PermissionsService,
    private routeparent: RouterService,
    private passervice: PasService,
    private ccService: CcService,
    private _snackBar: MatSnackBar,
    private location: Location,
    private stockService: StockService
  ) {
    this.formReport = formBuilder.group({
      cc_id: [0, Validators.required],
      code:[''],
      name: [''],
      validator: ['', Validators.required]
    });
    this.Columns = ['code','name', 'price','stock', 'cccode'];
  }
  selectedvalue: number; selectedview: string;
  cc: Icc[];
  stockstatus: stockstatus[];
  viewMoreOptions: boolean = false;


  ngOnInit() {
    this.formReport.controls['validator'].setValue('x');
    this.focusCode();

    this.message = "";
    //permisos
    this.Permissions = [];
    this.MenuG = [];
    this.permissionservice.getPermission("STOCK").subscribe(_Result => {
      if (_Result.body.length == 0)
        this.message = "No tiene permisos";
      for (const entry of _Result.body) {
        this.addPermission({ id: entry.id, function_code: entry.function_code, code: entry.code, description: entry.description, type: entry.type, icon: entry.icon, link: entry.link });
      }
      this.permissionsList = new MatTableDataSource<IuserPermissionsResponse>(this.Permissions);
      this.menuGList = new MatTableDataSource<IuserPermissionsResponse>(this.MenuG);
    },
      (e) => {
        this.message = e.error;
        console.log(e);
      });
    //cc
    this.cc = [];
    //this.ccService.getCCListV2().subscribe(results => {
    this.ccService.getCCList().subscribe(results => {
      if (results.body.isValid) {
        for (const entry of results.body.resultData) {
          this.addCc({ cc_id: entry.cc_id, cc_name: entry.cc_name });
        }
        this.formReport.controls['cc_id'].setValue(this.cc[0].cc_id)
      }
      else {
        alert(results.body.error.description);
      }
      (e) => {
        console.log(e);
      }
    });
  }

  moreOptionsFilter() {
    this.viewMoreOptions = !this.viewMoreOptions;
    this.focusCode();

  }

  Filter() {
    //stock
    this.formReport.controls['validator'].setValue('');
    const sl: stock = {
      cc_id: this.formReport.value.cc_id,
      code: this.formReport.value.code,
      name: this.formReport.value.name,
      stockstatus: 2
    };
    this.message = "Consultando...";
    this.DataGrid = [];
    this.r_gridregs = 0;
    this.stockService.getStockV1(sl).subscribe(results => {
      if (results.body.isValid) {
        for (const entry of results.body.resultData) {
          this.addData({
            cc_id: entry.cc_id, code: entry.code, name: entry.name.trim()+" "+entry.presentation.trim(), presentation: entry.presentation,
            groupname: entry.groupname, stock: entry.stock, cccode: entry.ccCode, price:entry.price
          });
        }
        this.dataList = new MatTableDataSource<stockResponse>(this.DataGrid);
        this.dataList.paginator = this.paginator;
        this.r_gridregs = this.dataList.data.length;
        this.message = "";
        //this.formReport.controls['code'].setValue('');
        this.formReport.controls['validator'].setValue('x');
      }
      else {
        this.openSB(results.body.error.description);
        this.message = "No hay datos";
        //this.formReport.controls['code'].setValue('');
        this.formReport.controls['validator'].setValue('x');

      }
      this.formReport.controls['code'].setValue('');
      this.focusCCId();
      //this.focusCode();


    },
      (e) => {
        this.openSB(e.error);
        this.message =e.error;

        console.log(e);
      });
  }




  addData(data) {
      this.DataGrid.push(data);
  }

  addPermission(permission) {
    this.Permissions.push(permission);
    if (permission.type == "G") {
          this.MenuG.push(permission);
    }
    else {
      switch (permission.code) {
        case "C": {
          this.Columns.push("b_det");
          break;
        }
      }
    }
  }

  addCc(V_cc) {
    try {
      this.cc.push(V_cc);
    }
    catch (e) {
      console.log(e);
    }
  }


  b_det(id, name) {
    this.routeparent.putRouter("paslist");
    this.passervice.putValues(id, name)
    this.router.navigate(['/pasdetail']);

  }

  b_back() {
    let _backRoute = this.routeparent.getBackRoute();
    this.router.navigate([_backRoute], { skipLocationChange: true });
  //  this.location.back();
  }


  b_gen(link, id) {
        this.router.navigate([link]);
  }

  openSB(msg) {
    this._snackBar.open(msg, '', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }

  selectAll(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }


  focusCode() {
    this.inputCodeRef.nativeElement.focus();
    /**--this.code;*/
  }

  focusCCId() {

    /**--this.code;*/
  }
}
